import { brandAssets } from '../lib/brand-assets.js';

type BrandLockupProps = {
  className?: string;
};

/** Monitor icon + wordmark for dark kiosk screens. */
export function BrandLockup({ className = '' }: BrandLockupProps) {
  return (
    <p className={`brand-lockup ${className}`.trim()}>
      <img
        src={brandAssets.monitorIcon}
        alt=""
        aria-hidden
        draggable={false}
        className="brand-lockup__icon"
      />
      <img
        src={brandAssets.wordmark}
        alt="GhostScreens"
        draggable={false}
        className="brand-lockup__wordmark"
      />
    </p>
  );
}
